import React from 'react';
import PropTypes from 'prop-types';
import ConnectButton from '../../../pages/_banner/ConnectButton';
import Wrapper from '../../../pages/_banner/Wrapper';
import useDialogLauncher from '../../_hooks/useDialogLauncher';
import { DialogManager } from '../../../dialogs_new/DialogManager';
import useRouter from '../../../hooks/useRouter';

ActiveBanner.propTypes = {
  project: PropTypes.object.isRequired
};

export default function ActiveBanner(props) {
  const { project, creator } = props;

  const launch = useDialogLauncher();
  const { history } = useRouter();

  function onViewMessage() {
    launch(DialogManager.ProjectManage.Config(project.id, '/manage'));
  }

  function onFindPartners() {
    launch(DialogManager.ProjectManage.Config(project.id, '/invite-populate'));
  }

  function onClose() {
    launch(DialogManager.ProjectClose.Config(project.id));
  }

  return (
    <Wrapper
      creator={creator}
      title={(
        <>
          Your project is active!
        </>
      )}
      subtitle={(
        <>
          Go find partners to invite or message those who have already responded.
        </>
      )}
    >
      <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
        <ConnectButton outline={true} onClick={onClose}>
          Close project
        </ConnectButton>
        <ConnectButton onClick={() => history.push('/manage')}>
          Manage partners
        </ConnectButton>
        {/*<ConnectButton disabled={true}>*/}
        {/*  This is you*/}
        {/*</ConnectButton>*/}
      </div>
    </Wrapper>
  );
};
